// React
import React from 'react';
import { Col, Row, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';

// Containers Injection
import { CardNestedList } from '../../components/NestedList';
import { PageWrapper } from '../../containers/componentsInjection';

export const ReportsPage = ({
  api,
  history,
  reports,
  setLoading,
  toggleLoading,
}) => {
  return (
    <PageWrapper title="Relatórios">
      <Row>
        <Col md={6}>
          <Card>
            <CardBody className="p-3">
              <ListGroup className="nested-list nested-sortable">
                {(reports || []).map((item) => (
                  <ListGroupItem className="nested-1" key={item.id}>
                    {' '}
                    <i
                      className={`${item.icon} fs-16 align-middle text-primary me-2`}
                    ></i>{' '}
                    {item.title}
                    {item.children.length > 0 && (
                      <ListGroup className="nested-list nested-sortable">
                        {item.children.map((item) => (
                          <ListGroupItem
                            key={item.id}
                            className="nested-2 card-animate"
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              history.push(item.route);
                            }}
                          >
                            <span className="user-select-none">
                              {item.title}
                            </span>
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    )}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </CardBody>
          </Card>
        </Col>

        <Col md={6}>
          <CardNestedList
            history={history}
            title="Ferramentas"
            icon="ri-tools-fill"
            subItems={[
              {
                subtitle: 'Exportação Rede de Farmácias',
                route: '/relatorios/exportacao-farmacia',
              },
              {
                subtitle: 'Exportação Associados Ativos',
                route: '#',
                dropdownActions: [
                  {
                    label: 'Apenas os Titulares',
                    onClick: () => {
                      toggleLoading();
                      api
                        .get('/services/export/holders')
                        .then((response) => {
                          const linkSource = `data:text/plain;base64, ${response.data}`;
                          const downloadLink = document.createElement('a');
                          const fileName = 'exportacao-titulares.xlsx';
                          downloadLink.href = linkSource;
                          downloadLink.download = fileName;
                          downloadLink.click();
                        })
                        .catch((error) => {
                          console.log(error);
                        })
                        .finally(() => {
                          setLoading(false);
                        });
                    },
                  },
                  {
                    label: 'Titulares e Dependentes',
                    onClick: () => {
                      toggleLoading();
                      api
                        .get('/services/export/all-customers')
                        .then((response) => {
                          const linkSource = `data:text/plain;base64, ${response.data}`;
                          const downloadLink = document.createElement('a');
                          const fileName =
                            'exportacao-titulares-e-dependentes.xlsx';
                          downloadLink.href = linkSource;
                          downloadLink.download = fileName;
                          downloadLink.click();
                        })
                        .catch((error) => {
                          console.log(error);
                        })
                        .finally(() => {
                          setLoading(false);
                        });
                    },
                  },
                ],
              },
            ]}
          />
        </Col>
      </Row>
    </PageWrapper>
  );
};
